var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-left",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1575 8.68004C20.1575 9.27004 19.6875 9.74004 19.0975 9.74004H3.6175L8.4275 14.55C8.8375 14.96 8.8375 15.64 8.4275 16.05C8.2175 16.26 7.9475 16.36 7.6775 16.36C7.4075 16.36 7.1375 16.26 6.9275 16.05L0.3075 9.43004C-0.1025 9.02004 -0.1025 8.35004 0.3075 7.93004L6.9175 1.31004C7.3275 0.900041 8.0075 0.890041 8.4175 1.31004C8.8275 1.72004 8.8375 2.39004 8.4175 2.81004L3.6175 7.62004H19.0975C19.6875 7.62004 20.1575 8.10004 20.1575 8.68004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.19ddfe5feeca46b0567412cd95ec1d09.svg";
export { ForwardRef as ReactComponent };